
import { useQuery } from '@tanstack/react-query';
import { api } from '../../services/api';
import { Task } from '@repo/shared-types';
import { taskSchema } from '@repo/shared-types/core/taskSchemas';
import { validateEntityArray } from '@repo/shared-utils';
import { logger } from '@repo/shared-utils';

/**
 * React Query hook to fetch admin tasks.
 * Automatically filters by current user's assignee name for PM/Admin roles.
 * @param assignee - Optional assignee name to filter by (if not provided, uses current user)
 * @returns Query result containing tasks array
 */
export const useTasks = (assignee?: string) => {
  return useQuery({
    queryKey: ['tasks', assignee || 'current-user'],
    queryFn: async () => {
      const data = await api.tasks.list(assignee);
      // ✅ Validate query response with Zod schema
      const validation = validateEntityArray(taskSchema, data);
      if (!validation.valid) {
        logger.error('Invalid tasks query response:', validation.errors);
        throw new Error('Invalid tasks data received from API');
      }
      return validation.data! as Task[];
    },
    staleTime: 1000 * 60, // Data is fresh for 1 minute
  });
};

